import React, { useState } from 'react';
import ClientRequestsDashboard from './ClientRequestsDashboard';
import ClientSearchProviders from './ClientSearchProvider';
import ChatComponent from './ChatComponent';
import ProviderRequestsDashboard from './ProviderRequestDashboard';
import ReviewForm from './ReviewForm';

const OoshDashboard = () => {
  const [view, setView] = useState('search'); 
  const [currentServiceId, setCurrentServiceId] = useState(null);

  const handleRequest = (service) => {
    setView('clientRequests');
  };

  const handleChat = (serviceId) => {
    setCurrentServiceId(serviceId);
    setView('chat');
  };

  const handleReview = (serviceId) => {
    setCurrentServiceId(serviceId);
    setView('review');
  };
 
  const handleReviewComplete = () => {
    setView('clientRequests');
    setCurrentServiceId(null);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <nav className=" p-4  flex justify-center gap-4">
        <button onClick={() => setView('search')} className="hover:underline">Search Providers</button>
        <button onClick={() => setView('clientRequests')} className="hover:underline">My Requests</button>
        <button onClick={() => setView('providerRequests')} className="hover:underline">Provider Dashboard</button>
      </nav>
      <div className="p-6">
        {view === 'search' && <ClientSearchProviders onRequest={handleRequest} />}
        {view === 'clientRequests' && <ClientRequestsDashboard onChat={handleChat} onReview={handleReview} />}
        {view === 'providerRequests' && <ProviderRequestsDashboard />}
        {view === 'chat' && <ChatComponent serviceId={currentServiceId} />}
        {view === 'review' && <ReviewForm serviceId={currentServiceId} onComplete={handleReviewComplete} />}
      </div>
    </div>
  );
};

export default OoshDashboard;